import { Component, Input, OnInit } from '@angular/core';

export enum InlineMessageType {
  Info = 'info',
  InfoBlue = 'info-blue',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

export enum TitleFillStatus {
  TitleEmpty = 'title-empty',
  TitleFilled = 'title-filled',
}

@Component({
  selector: 'cds-inline-message',
  templateUrl: './inline-message.component.html',
  styleUrls: ['./inline-message.component.scss'],
})
export class InlineMessageComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() type: InlineMessageType = InlineMessageType.Info;
  @Input() titleFillStatus: TitleFillStatus = TitleFillStatus.TitleEmpty;

  constructor() {}

  ngOnInit() {}
}
